import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as authConstants from '../../../constants/auth';

import * as authActionCreators from '../../../actions/auth';
import * as loginActionCreators from '../../../actions/login';
let allActionCreators = Object.assign({}, authActionCreators, loginActionCreators);

import {saveLogin} from '../../../utils/auth';
import {emailValidation, codeValidation} from '../../../utils/itemValidation';

import TextField from 'material-ui/TextField';


class Login extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      requestPending: false,
      serverError: null,
      // inputCode: '',
      inputEmail: '',
      // errorCode: null,
      errorEmail: null,
    };
  }

  changeCode(evt) {
    this.setState({ inputCode: evt.target.value });
  }

  // validateCode() {
  //   if(this.state.inputCode) {
  //     this.setState({ errorCode: codeValidation(this.state.inputCode) });
  //   }
  // }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value });
  }

  validateEmail() {
    if(this.state.inputEmail) {
      this.setState({ errorEmail: emailValidation(this.state.inputEmail) });
    }
  }

  validateAll() {
    // let codeError = codeValidation(this.state.inputCode);
    let emailError = emailValidation(this.state.inputEmail);

    this.setState({
      // errorCode: codeError,
      errorEmail: emailError,
    });
    if(
      emailError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });

      let loginData = {
        code: this.state.inputCode,
        email: this.state.inputEmail,
      }

      this.props.callLogin(loginData)
      .then((respData) => {
        this.setState({
          requestPending: false,
          serverError: null,
        });
        saveLogin(respData.auth.auth_token);
        this.props.authSave(respData.auth.auth_token, Date.now() + authConstants.LOGOUT_TIME);
        this.context.router.push('/');
      })
      .catch((errorData) => {
        let errorMessage = errorData.message ? errorData.message : 'Cannot connect to Dallas Luxury Catalog';
        this.setState({
          requestPending: false,
          serverError: errorMessage,
        });
      });
    } 
  }

  render() {
    return <div className='Login'>
      <div className='loginWrapper'>
        <div className='loginLogo'>
          <img src='/img/dallas2020/assets/gold_logo.svg' alt='Diamonds Direct' />
        </div>
        <div className='loginHr'>
          <img src='/img/dallas2020/assets/gold_logoline.svg' alt='Diamonds Direct' />
        </div>
        {this.state.serverError ? 
          <div className='loginError'>{this.state.serverError}</div> :
          null
        }
        <div className='ResponsiveForm'>
          <div className='formRow'>
            <div className='inputWrapper'>
              <input
                type='email'
                className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                placeholder='ENTER EMAIL'
                value={this.state.inputEmail} 
                onChange={::this.changeEmail} 
                onBlur={::this.validateEmail}
                required />
            </div>
          </div>
          <div className='formRow'>
            <div className='inputWrapper'>
              <div
                className={'loginSubmit actionButton'}
                onClick={::this.handleSubmit}
                disabled={this.state.requestPending}>
                Enter
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}
export default Login;

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export const LoginContainer = connect(
  mapStateToProps,
  allActionCreators
)(Login);


// WEBPACK FOOTER //
// ./src/components/views/login/Login.jsx